var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item',{attrs:{"clickable":"","to":{ name: _vm.name }}},[(_vm.icon)?_c('q-item-section',{attrs:{"avatar":""}},[_c('q-icon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_c('q-item-section',[_c('q-item-label',[_vm._v(_vm._s(_vm.title))]),_c('q-item-label',{attrs:{"caption":""}},[_vm._v(" "+_vm._s(_vm.caption)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }